<template>
  <div class="row">
    <div class="col-md-12">
      <span>{{ contactName }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'contact-summary',
  props: {
    contact: Object
  },
  computed: {
    contactName() {
      let _name = ''
      if (this.contact !== undefined && this.contact !== null) {
        _name = `for ${this.firstName} ${this.lastName}`
        // If no first or last name, use firm name
        if ((this.firstName === '' || this.firstName === undefined || this.firstName === null) && (this.lastName === '' || this.lastName === undefined || this.lastName === null)) {
          _name = `for ${this.contact.firmName}`
        }
      }
      return _name
    },
    firstName() {
      return this.contact !== undefined && this.contact !== null && this.contact.firstName !== null ? this.contact.firstName : ''
    },
    lastName() {
      return this.contact !== undefined && this.contact !== null && this.contact.lastName !== null ? this.contact.lastName : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contacts/forms/contact-summary.vue